import React, { useState } from "react";
import { TooltipsAndPopovers, TooltipsModal, PopoverModal } from "../../../../../Constant";
import { Btn, H5, P, ToolTip } from "../../../../../AbstractElements";
import CommonModal from "../../Common/CommonModal";

export const ToolTipAndPopover = () => {
  const [toolAndPopover, setToolAndPopover] = useState(false);
  const tooltipsAndPopoversToggle = () => setToolAndPopover(!toolAndPopover);
  const [tooltipBtn, setTooltipBtn] = useState(false);
  const toggleBtn = () => setTooltipBtn(!tooltipBtn);
  const [tooltipLinkOne, setTooltipLinkOne] = useState(false);
  const toggleLinkOne = () => setTooltipLinkOne(!tooltipLinkOne);

  return (
    <div>
      <Btn color="info" type="button" onClick={tooltipsAndPopoversToggle}>{TooltipsAndPopovers}</Btn>
      <CommonModal fade={true} isOpen={toolAndPopover} toggle={tooltipsAndPopoversToggle} title="Tooltip and Popover Moda">
        <H5>{PopoverModal}</H5>
        <P className="mt-2">
          {`This `}
          <Btn color="success" className="popover-test" id="Tooltip-ModalBtnProp" onClick={toggleBtn}>button</Btn>
          {` triggers a popover on click.`}
          <ToolTip autohide placement="top" target="Tooltip-ModalBtnProp" isOpen={tooltipBtn} toggle={toggleBtn}>this is amazing content</ToolTip>
        </P>
        <hr />
        <H5>{TooltipsModal}</H5>
        <P className="mt-2">
          <a className="tooltip-test text-info" href="#javascript" id="Tooltip-BtnOne">{` This link `}</a>
          <ToolTip placement="top" target="Tooltip-BtnOne" isOpen={tooltipLinkOne} toggle={toggleLinkOne}>Tooltip</ToolTip>
          and
          <a className="tooltip-test text-info" href="#javascript" id="Tooltip-BtnOne">{` that link `}</a>
          <ToolTip placement="top" target="Tooltip-BtnOne" isOpen={tooltipLinkOne} toggle={toggleLinkOne}>Tooltip</ToolTip>
          have tooltips on hover.
        </P>
      </CommonModal>
    </div>
  );
};
